import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { PaymentOption } from '../../models/insurance.model';

@Component({
  selector: 'ez-slider',
  imports: [CurrencyPipe],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
})
export class SliderComponent implements OnInit {
  @Input({ required: true }) steps: PaymentOption[];
  @ViewChild('slider') inputElement: ElementRef<HTMLInputElement>;
  @Output() isEnabled = new EventEmitter<void>();
  readonly currentValue = signal<PaymentOption | undefined>(undefined);
  readonly isDisabled = signal(false);

  ngOnInit(): void {
    this.steps.sort((a, b) => this.smallestToBiggest(a, b));
    this.currentValue.set(this.steps[0]);
    this.isDisabled.set(false);
  }
  smallestToBiggest(a: PaymentOption, b: PaymentOption) {
    return a.additionalPaymentAmount - b.additionalPaymentAmount;
  }
  updateValue() {
    //manually update currentValue to steps' value since the numbers inside of the steps array don't necessarily have a uniform interval
    const currentIndex = +this.inputElement.nativeElement.value - 1;
    this.currentValue.set(this.steps[currentIndex]);
  }
  @HostListener('click', ['$event']) @HostListener('keydown', ['$event']) @HostBinding('tabindex') setEnabled(
    event: Event,
  ) {
    if (event instanceof KeyboardEvent && event.key === 'Tab') {
      return; //should not be enabled by tabbing to the next interactable element
    }
    if (!(event instanceof ToggleEvent) && event.type !== 'detailsOpened' && this.isDisabled()) {
      this.isEnabled.emit(); //emit event when slider is activated by click
    }
    this.isDisabled.set(false);
    this.inputElement.nativeElement.focus();
    return -1;
  }
  @HostBinding('tabindex') public setDisabled() {
    this.isDisabled.set(true);
    return 0;
  }
}
